import { Plan } from 'src/pages/deprecated/payment/types';
import { GIFT_CAMPAIGN } from './constants';

export const isPlanGiftEligible = (plan: Plan | null | undefined): boolean => {
  if (!plan) return false;
  if (!GIFT_CAMPAIGN.enabled) return false;
  if (plan.interval !== 'month') return false;
  return GIFT_CAMPAIGN.eligibleIntervalMonths.includes(plan.intervalCount);
};

export const joinPlanLabels = (labels: string[]): string => {
  if (labels.length === 0) return '';
  if (labels.length === 1) return labels[0];
  if (labels.length === 2) return `${labels[0]} or ${labels[1]}`;
  const head = labels.slice(0, -1).join(', ');
  const tail = labels[labels.length - 1];
  return `${head} or ${tail}`;
};
